// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2cyPR","Active":"Header_Active__2rYVe"};